import { Card, Text } from "@overmap-ai/blocks"
import { type Issue, type Stored, UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import React, { memo } from "react"

import { IssueTimelineItemType } from "../../enums/issues"
import { issueTimelineItemTypeData } from "../../mappings/issues"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { IssueTimelineSize } from "./typings"

interface IssueTimelineCreatedItemProps {
	issue: Stored<Issue>
	size: IssueTimelineSize
}

export const IssueTimelineCreatedItem = memo<IssueTimelineCreatedItemProps>((props) => {
	const { issue, size } = props

	const createdBy = useAppSelector(selectUserById(issue.created_by ?? -1))
	const { icon } = issueTimelineItemTypeData[IssueTimelineItemType.CREATED]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;created issue
					<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(issue.submitted_at)}</Text>
				</Text>
				<Text accentColor="base" className="min-w-0 truncate" size={size}>
					<IssueTypeIcon issueTypeId={issue.issue_type} className="align-sub" />
					&nbsp;
					<IssueIndexLabel issueId={issue.uuid} highContrast />
					&nbsp;
					<Text accentColor="base">{issue.title || UNTITLED_ISSUE_TITLE}</Text>
				</Text>
			</Card>
		</div>
	)
})
IssueTimelineCreatedItem.displayName = "IssueTimelineCreatedItem"
